<template>
    <div>
      <div v-show="!jobId">
        <div class="mb-2"><strong>Export all your conversations</strong></div>
        <div v-show="!jobId" class="bg-blue text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': loading}" @click="startExport()">{{ loading ? 'Exporting...' : 'Export' }}</div>
      </div>

      <div v-if="jobId">
          <div v-if="done" class="mt-2">
            <div class="mb-2"><strong>Data ready! A total of {{ total }} conversations were prepared for download.</strong></div>
            <a :href="url" class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" style="color: #FFFFFF !important;">Download ZIP</a>
          </div>
          <div v-else>
            <div class="mb-2"><strong>Preparing your data...</strong></div>
            <v-progress-linear :value="percentage" color="green" height="20" class="p-2">
              <div style="color: #FFFFFF;">{{ processed }}/{{ total }}</div>
            </v-progress-linear>
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      jobId: null,
      total: 0,
      processed: 0,
      done: false,
      url: '',
      loading: false,
      intervalId: null
    };
  },
  computed: {
    percentage() {
      return this.total ? Math.round((this.processed / this.total) * 100) : 0;
    }
  },
  methods: {
    startExport() {
      this.loading = true;
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/export', {}, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        })
        .then((res) => {
          this.jobId = res.data.jobId;
          this.pollProgress();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pollProgress() {
      this.intervalId = setInterval(async () => {
        let res = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/export/' + this.jobId, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        });
        this.total = res.data.total;
        this.processed = res.data.processed;
        this.done = res.data.done;
        if (this.done) {
          this.url = res.data.url;
          clearInterval(this.intervalId);
        }
      }, 2000);
    }
  }
};

</script>